// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V22H14.8762C14.0139 20.897 13.5 19.5085 13.5 18C13.5 16.61 13.9363 15.3219 14.6794 14.2652L9 8.58579L4 13.5858V4H20V11.5C20.6978 11.5 21.3699 11.61 22 11.8135V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 5.25C14.4812 5.25 13.25 6.48122 13.25 8C13.25 9.51878 14.4812 10.75 16 10.75C17.5188 10.75 18.75 9.51878 18.75 8C18.75 6.48122 17.5188 5.25 16 5.25Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 16V14H16V16H19V23H21V16H24Z"}}]};

const VisualRecognitionFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'visual-recognition-filled',
    ref,
    icon: element,
  },
));

VisualRecognitionFilledIcon.displayName = 'VisualRecognitionFilledIcon';

export default VisualRecognitionFilledIcon;
